export default axiosInstance => ({
  /**
   * Login a user to the Mirakl api
   * @param {Object} userCredentials - email and password
   * @return {Promise} retour axios
   */
  login(userCredentials) {
    return axiosInstance.post("/login_check", userCredentials);
  },
  /**
   * Return all Mirakl module users
   * @return {Promise} retour axios
   */
  list() {
    return axiosInstance.get("/users");
  }
});
